import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";

declare var ko: any;

export class newsletterMailList_template extends vnTemplate {

    // As VM
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected filter: filterSimple_template;

    protected initPartial() {
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {
        return {
            filters: {
                keyword: this.getTemplateViewModel().filter.filterKeyword
            },
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
        }
    }

    protected buildViewModel(): any {
        const self = this
        return {
            newslettermails: ko.observableArray([]),
            orderBy: ko.observable("dateUpdated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateUpdated_DESC"),
            idNewsletterMailToDelete: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_email_view', 'newsletter_email_edit'])),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewNewsletterMail: (data, event) => {
                self.viewNewsletterMail(data.id, event);
            },
            preview: (value, data, event) => {
                self.preview(value);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickShowPopUp : (data, event) =>{
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event)=>{
                self.onClickHidePopUp()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            },
            capitalizeFirstLetter: (string) => {
                if (typeof string !== 'string') {
                    return '';
                }
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
        <div class="list-header w-justify">
            <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd},  visible: permissions()['newsletter_email_edit'].read" class="btn secondary icon i-add" type="button">Create Email</button>
            </div>
            <div class="w-center" >
                ` + this.filter.getHtmlBuild() + `
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>

        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'subject') }, css: { 'list-sort-desc': orderByAndDirection()=='subject_DESC', 'list-sort-asc': orderByAndDirection()=='subject_ASC' }">Subject</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'mode') }, css: { 'list-sort-desc': orderByAndDirection()=='mode_DESC', 'list-sort-asc': orderByAndDirection()=='mode_ASC' }">Layout</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'selectedTemplate') }, css: { 'list-sort-desc': orderByAndDirection()=='selectedTemplate_DESC', 'list-sort-asc': orderByAndDirection()=='selectedTemplate_ASC' }">Template</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Reference</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Creation Date</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Update Date</span></th>
                            <th class="align-right"><span>Delete</span></th>
                            </tr>
                    </thead>
                    <tbody data-bind="foreach: newslettermails">
                        <tr class="cursor">
                            <td data-bind=" if: subject, event: { click: $parent.viewNewsletterMail }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <div class="flex"><span data-bind="text: subject"></span></div>
                                </a>
                            </td>
                            <td data-bind=" if: mode, event: { click: $parent.viewNewsletterMail }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <div class="flex"><span data-bind="text: $parent.capitalizeFirstLetter(mode) "></span></div>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.viewNewsletterMail }">
                                <a class="right-click" data-bind="attr: { href : emakiView }">
                                    <div class="flex"><span data-bind="text: $parent.capitalizeFirstLetter(selectedTemplate ? selectedTemplate.name : '')"></span></div>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.viewNewsletterMail }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.viewNewsletterMail }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewNewsletterMail }"><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span></a></td>
                            <td class="align-right">
                                <button type="button" data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false, visible: $parent.permissions()['newsletter_email_edit'].delete" class="btn border only-icon icon i-delete"></button>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>


            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting Newsletter Mail</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this mail

                                    <p data-bind=" if: idNewsletterMailToDelete() !== null ">
                                       <span data-bind="text: idNewsletterMailToDelete().name"></span>
                                    </p>

                                </p>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>

                </div>
            </div>
        `);
    }

    protected getTemplateName(): string {
        return "newsletterMailList_template";
    }

    protected getMainElementClasses(): string[] {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewNewsletterMail(data, event): any {
        this.caller.viewNewsletterMail(data)
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            // default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.newsletterMailListReorder();
    }

    private preview(value) {

        // prevent click to trigger onClick bindings of outer elements that are also targeted by click
        window.event.stopPropagation();
        this.caller.preview(value.permalink);
    }

    onClickAdd(): any {
        this.caller.addNewsletterMail()
    }

    onClickDelete() {
        const newsletterMailId = this.getTemplateViewModel().idNewsletterMailToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteNewsletterMail(newsletterMailId);
    }

    onClickHidePopUp(): any {
        this.getTemplateViewModel().idNewsletterMailToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    onClickShowPopUp(data): any {

        this.getTemplateViewModel().idNewsletterMailToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    // Action on view model
    protected setNewsletterMails(newslettermails, brandId) {

        newslettermails.forEach((nm) => nm['emakiView'] = '/brand/' + brandId + '/newsletter/emails/view/' + nm.id + '/');
        this.getTemplateViewModel().newslettermails(newslettermails)
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterMailList_template.ts